/*
*
* File JS componente Submenu
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './submenu.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const submenu = () => {

   const context = document.querySelector('.submenu');
   if(!context) return;
   const triggerSubMenu = context.querySelector('#triggerSubMenu');
   const itemsSubMenu = context.querySelector('.submenu__items');
   if(!triggerSubMenu || !itemsSubMenu) return;

   triggerSubMenu.addEventListener('click' , (e) => {
        e.preventDefault();
        itemsSubMenu.classList.toggle('open');
        context.classList.toggle('open')
   });

    // Controlla se il clic è avvenuto al di fuori dell'elemento .submenu
    document.addEventListener('click', function(e) {    
        const targetElement = e.target;

        if (!context.contains(targetElement)) {
            context.classList.remove('open');
            itemsSubMenu.classList.remove('open');
          }
    });


}



export default submenu;

//--------------------------------------------------------------------//